import { authHeader } from '@/helpers/auth-header';
import { buildUsersUrl,  buildSendOtpUrl, buildVerifyOtpUrl} from '@/helpers/api-url-builder';
import { responseToJson, storeToken, handleResponse, handleLogout } from '@/helpers/response-helpers';

export const userService = {
  login,
  sendOtp,
  verifyOtp,
  logout,
  setPassword,
  forgotPassword,
  getMe,
  updateUser,
  sendSupportEmail,
  inviteUser
};

const headers = {
  'Content-Type': 'application/json',
  'Accept': 'application/json'
};

// API calls

function login(user) {
  const requestOptions = {
    method: 'POST',
    headers,
    body: JSON.stringify({ user })
  };

  return fetch(buildUsersUrl('login'), requestOptions)
    .then(handleResponse)
    .then(response => {
      if (response.requiresOtp) {
        return { requiresOtp: true };
      } else {
        return storeToken(response).then(responseToJson);
      }
    });
}

function sendOtp() {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...headers,
      ...authHeader()
    }
  };

  return fetch(buildSendOtpUrl('send'), requestOptions)
    .then(handleResponse)
    .then(responseToJson);
}

function verifyOtp(otp) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...headers,
      ...authHeader()
    },
    body: JSON.stringify({ otp })
  };
  console.log("verification reached here");
  return fetch(buildVerifyOtpUrl(), requestOptions)
    .then(handleResponse)
    .then(responseToJson);
}


function logout() {
  const requestOptions = {
    method: 'DELETE',
    headers: {
      ...headers,
      ...authHeader()
    },
  };

  return fetch(buildUsersUrl('logout'), requestOptions)
          .then(() => handleLogout());
}

function setPassword(user) {
  const requestOptions = {
    method: 'PUT',
    headers,
    body: JSON.stringify({ user })
  };

  return fetch(buildUsersUrl('password'), requestOptions)
          .then(handleResponse)
          .then(responseToJson);
}

function forgotPassword(email) {
  const requestOptions = {
    method: 'POST',
    headers,
    body: JSON.stringify({ user: { email } })
  };

  return fetch(buildUsersUrl('password'), requestOptions)
          .then(handleResponse)
          .then(responseToJson);

}
function getMe() {
  const requestOptions = {
    method: 'GET',
    headers: {
      ...headers,
      ...authHeader()
    }
  };

  return fetch(buildUsersUrl('me'), requestOptions)
          .then(handleResponse)
          .then(responseToJson);
}

function updateUser(user) {
  const requestOptions = {
    method: 'PUT',
    headers: {
      ...headers,
      ...authHeader()
    },
    body: JSON.stringify({ user })
  };

  return fetch(buildUsersUrl(), requestOptions)
          .then(handleResponse)
          .then(responseToJson);
}


function sendSupportEmail(email){
  const requestOptions = {
    method: 'POST',
    headers: {
      ...headers,
      ...authHeader()
    },
    body: JSON.stringify(email)
  };
  return fetch(buildUsersUrl('send_support_email'), requestOptions)
    .then(handleResponse)
    .then(responseToJson);
}

function inviteUser(user) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...headers,
      ...authHeader()
    },
    body: JSON.stringify({ user })
  };

  return fetch(buildUsersUrl('invite'), requestOptions)
          .then(handleResponse)
          .then(responseToJson);
}
